import { myAxios } from "./axios";

export function getStatusDeals(payload = {}, { page, limit } = {}) {
    const config = {
        params: {
            page,
            limit,
            ...payload,
        },
    };
    return myAxios.get("/status-deals", config);
}

export function getStatusDeal(id) {
    return myAxios.get("/status-deals/" + id);
}

export function addStatusDeal(data) {
    return myAxios.post("/status-deals/add/", data);
}

export function editStatusDeal(id, data) {
    return myAxios.put("/status-deals/edit/" + id, data);
}

export function deleteStatusDeal(id) {
    return myAxios.delete("/status-deals/" + id);
}
